// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608170834/js/" + chunkId + "." + {"44":"21864d77","225":"0419f234","481":"9ffc6fd8","486":"ed2d8913","770":"d09aa284"}[chunkId] + ".0.15711575803295508.chunk.js";
};